import {useTranslation} from "react-i18next";

interface DLPTableHeaderProps {
    caption? : string
    children?: React.ReactNode
}

export const DLPTableHeader = ({caption, children} : DLPTableHeaderProps ) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    return (
        <>
            {caption !== undefined && <caption>{caption}</caption>}
            <thead className="sticky-top">
            <tr className="text-nowrap">
                <th className="th-w-min">{children}</th>
                <th>{t("dlp-table-header.name")}</th>
                <th>{t("dlp-table-header.description")}</th>
                <th>{t("dlp-table-header.regex")}</th>
                <th>{t("dlp-table-header.validator")}</th>
                <th>{t("dlp-table-header.threshold")}</th>
                <th>{t("dlp-table-header.action")}</th>
                <th>{t("dlp-table-header.delayed-eval")}</th>
                <th>{t("dlp-table-header.match-filter")}</th>
            </tr>
            </thead>
        </>
    )
}
